const OSS = require('ali-oss')
import { getOsstoken } from '@/api/index'
//把file文件转为base64
function getBase64(file) {
    return new Promise((resolve, reject) => {
        ///FileReader类就是专门用来读文件的
        const reader = new FileReader()
        //开始读文件
        //readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串，
        reader.readAsDataURL(file)
        // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
        reader.onload = () => resolve(reader.result)
        // 失败返回失败的信息
        reader.onerror = error => reject(error)
    })
}
//获取文件大小
function getfileSize(val) {
    if (val === 0) return "0 B"
    var k = 1024;
    var sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    let i = Math.floor(Math.log(val) / Math.log(k))
    return ((val / Math.pow(k, i)).toFixed(2) + "" + sizes[i])
}
//时间格式转换
function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}
//阿里云分片上传
function uploadOssMultipart(file, options) {
    return new Promise(async (resolve, reject) => {
        getOsstoken().then(res => {
            if (res.code == 1) {
                const client = new OSS({
                    secure: res.data.secure, // 上传链接返回支持https
                    region: res.data.region, // 填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                    accessKeyId: res.data.AccessKeyId,
                    accessKeySecret: res.data.AccessKeySecret,
                    bucket: res.data.bucket, // 填写Bucket名称
                    stsToken: res.data.SecurityToken //上传token
                })
                 //  唯一的文件名这个规则需要在阿里云哪里配置好
                const fileName = '/uploads/' + parseTime(file.lastModifiedDate, '{y}{m}{d}/') + file.lastModified + file.fileName 
                resolve(client.multipartUpload(fileName, file.file, { ...options }))
            }
        })

    })
}
//阿里云普通上传
function uploadOssPut(file) {
    return new Promise(async (resolve, reject) => {
        getOsstoken().then(res => {
            if (res.code == 1) {
                const client = new OSS({
                    secure: res.data.secure, // 上传链接返回支持https
                    region: res.data.region, // 填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                    accessKeyId: res.data.AccessKeyId,
                    accessKeySecret: res.data.AccessKeySecret,
                    bucket: res.data.bucket, // 填写Bucket名称
                    stsToken: res.data.SecurityToken
                })
                const fileName = '/uploads/' + parseTime(file.lastModifiedDate, '{y}{m}{d}/') + file.name
                //  配置路径以及文件名称
                resolve(client.put(fileName, file))
                // 或者返回如下：
                // resolve({
                //     fileUrl: `${OSSConfig.uploadHost}/${fileName}`,
                //     fileName: file.name
                // })
            }
        })

    })
}
export { uploadOssPut, uploadOssMultipart,getfileSize,getBase64}

